const head = document.getElementsByTagName("head")[0];

function updateFavicon(favico) {
  let ico = head.getElementsByClassName("icon-maketplace")[0];
  ico.href = favico;
}

export default updateFavicon;
